<article class="tt-ai-chat-message">
    <div class="tt-ai-chat-message__message tt-ai-chat-message__message--question">
        <div class="tt-ai-chat-message__frame tt-ai-chat-message__frame--question" [class.tt-ai-chat-message__frame--ready]="isFrameReady('prompt', message.prompt)">
            <div *ngIf="!isFrameReady('prompt', message.prompt)" class="tt-ai-chat-message__skeleton" aria-hidden="true"><span></span><span></span><span></span></div>
            <iframe
                class="tt-ai-chat-message__html"
                sandbox="allow-same-origin"
                scrolling="no"
                [attr.title]="'Prompt ' + (messageIndex + 1)"
                [srcdoc]="getTrustedHtml('prompt', message.prompt)"
                (load)="resizeFrame($event, 'prompt')"
            ></iframe>
        </div>
    </div>
    <div *ngIf="message.polling && !message.response && !message.error_message" class="tt-ai-chat-message__reasoning">
        <tt-ai-chat-thinking></tt-ai-chat-thinking>
        <div
            *ngIf="message.reasoning_status"
            class="tt-ai-chat-message__frame tt-ai-chat-message__frame--reasoning"
            [class.tt-ai-chat-message__frame--ready]="isFrameReady('reasoning', reasoningMarkdownSource)"
        >
            <div *ngIf="!isFrameReady('reasoning', reasoningMarkdownSource)" class="tt-ai-chat-message__skeleton" aria-hidden="true"><span></span><span></span></div>
            <iframe
                #reasoningFrame
                class="tt-ai-chat-message__html"
                sandbox="allow-same-origin"
                scrolling="no"
                [attr.title]="'AI reasoning summary ' + (messageIndex + 1)"
                [srcdoc]="getTrustedMarkdown(reasoningMarkdownSource)"
                (load)="resizeFrame($event, 'reasoning')"
            ></iframe>
        </div>
    </div>
    <div *ngIf="message.response" class="tt-ai-chat-message__message tt-ai-chat-message__message--response">
        <div class="tt-ai-chat-message__frame tt-ai-chat-message__frame--response" [class.tt-ai-chat-message__frame--ready]="isFrameReady('response', message.response)">
            <div *ngIf="!isFrameReady('response', message.response)" class="tt-ai-chat-message__skeleton" aria-hidden="true"><span></span><span></span><span></span></div>
            <iframe
                class="tt-ai-chat-message__html"
                sandbox="allow-same-origin"
                scrolling="no"
                [attr.title]="'AI response ' + (messageIndex + 1)"
                [srcdoc]="getTrustedHtml('response', message.response)"
                (load)="resizeFrame($event, 'response')"
            ></iframe>
        </div>
    </div>
    <tt-toast *ngIf="message.error_message" role="alert" ttType="danger">
        <span title style="white-space: break-spaces">{{ message.error_message }}</span>
    </tt-toast>
</article>
